/*eslint-disable*/
import React from "react";
import { Link } from "react-router-dom";
import classNames from "classnames";
import PropTypes from "prop-types";
import { NavLink, useParams, useLocation } from "react-router-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Collapse from "@material-ui/core/Collapse";
import Icon from "@material-ui/core/Icon";

import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Home from "@material-ui/icons/Home";

import styles from "assets/jss/components/sidebarStyle.js";

const useStyles = makeStyles(styles);

export default function Sidebar(props) {
  const classes = useStyles();
  const {pathname} = useLocation();
  const {name} = useParams()
  const [collapse, setCollapse] = React.useState({
    openShipping: activeRoute("/shipping-address"),
    openFaq: activeRoute("/faq"),
    openRegister: activeRoute("/register"),
    openQuestionnaire: activeRoute("/questionnaire"),
    openSerialCode: activeRoute("/serial-code"),
    openSurvey: activeRoute("/survey"),
  });

  // verifies if routeName is the one active (in browser input)
  function activeRoute(routeName) {
    return pathname.indexOf(routeName) >= 0;
  }
  function openCollapse(val) {
    var st = Object.assign({}, collapse);
    st[val] = !collapse[val];
    setCollapse(st);
  }

  const {routes} = props;
  const infoFontClasses = classNames({
    [" " + classes.infoFont]: activeRoute(`/project/${name}/overview`)
  });
  const brand = (
    <div className={classes.logo}>
      <NavLink
          to={`/project/${name}/overview`}
          className={classNames(classes.logoLink, infoFontClasses)}
      >
        <Icon className={classNames(classes.itemIcon, infoFontClasses)} >
          <Home />
        </Icon>
        {name}
      </NavLink>
    </div>
  );
  const links = (
      <List className={classes.list}>
        {routes.map((prop, key) => {
          const {name} = useParams();
          if (prop.collapse) {
            return (
              <div key={key} className={classes.item}>
                <div onClick={() => openCollapse(prop.state)}>
                  <ListItem button className={classes.itemLink}>
                    {typeof prop.icon === "string" ? (
                        <Icon
                            className={classNames(classes.itemIcon)}
                        >
                          {prop.icon}
                        </Icon>
                    ) : (
                        <prop.icon
                            className={classNames(classes.itemIcon)}
                        />
                    )}
                    <ListItemText
                        primary={prop.name}
                        className={classNames(classes.itemText)}
                        disableTypography={true}
                    />
                  {collapse[prop.state] ? <ExpandLess /> : <ExpandMore />}
                  </ListItem>
                </div>
                <Collapse in={collapse[prop.state]} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    {
                      prop.views.filter(prop => prop.render).map((prop, key) => {
                        const path = prop.path.replace(':name', name);
                        const listItemClasses = classNames({
                          [" " + classes.blue]: activeRoute(path)
                        });
                        const whiteFontClasses = classNames({
                          [" " + classes.whiteFont]: activeRoute(path)
                        });
                        return (
                          <NavLink
                              to={path}
                              activeClassName="active"
                              key={key}
                          >
                            <ListItem button className={classNames(classes.itemLink, classes.itemLinkCol, listItemClasses)}>
                              <ListItemText
                                  primary={prop.name}
                                  className={classNames(classes.itemText, whiteFontClasses)}
                                  disableTypography={true}
                              />
                            </ListItem>
                          </NavLink>
                        )
                      })
                    }
                  </List>
                </Collapse>
              </div>
            )
          }
          const path = prop.path.replace(':name', name);
          const listItemClasses = classNames({
            [" " + classes.blue]: activeRoute(path)
          });
          const whiteFontClasses = classNames({
            [" " + classes.whiteFont]: activeRoute(path)
          });
          return (
              <NavLink
                  to={path}
                  className={classes.item}
                  activeClassName="active"
                  key={key}
              >
                <ListItem button className={classes.itemLink + listItemClasses}>
                  {typeof prop.icon === "string" ? (
                      <Icon
                          className={classNames(classes.itemIcon, whiteFontClasses)}
                      >
                        {prop.icon}
                      </Icon>
                  ) : (
                      <prop.icon
                          className={classNames(classes.itemIcon, whiteFontClasses)}
                      />
                  )}
                  <ListItemText
                      primary={prop.name}
                      className={classNames(classes.itemText, whiteFontClasses)}
                      disableTypography={true}
                  />
                </ListItem>
              </NavLink>
          );
        })}
      </List>
  );
  return (
    <div>
      <Hidden mdUp implementation="css">
        <Drawer
          anchor="left"
          variant="temporary"
          open={props.open}
          classes={{
            paper: classes.drawerPaper
          }}
          onClose={props.handleDrawerToggle}
          ModalProps={{
            keepMounted: true // Better open performance on mobile.
          }}
        >
          {brand}
          <div className={classes.sidebarWrapper}>{links}</div>
        </Drawer>
      </Hidden>
      <Hidden smDown implementation="css">
        <Drawer
          anchor="left"
          variant="permanent"
          open
          classes={{
            paper: classes.drawerPaper
          }}
          onClose={props.handleDrawerToggle}
          ModalProps={{
            keepMounted: true // Better open performance on mobile.
          }}
        >
          {brand}
          <div className={classes.sidebarWrapper}>{links}</div>
        </Drawer>
      </Hidden>
    </div>
  );
}

Sidebar.propTypes = {
  handleDrawerToggle: PropTypes.func,
  routes: PropTypes.arrayOf(PropTypes.object),
  open: PropTypes.bool
};
